import { useState } from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import TourGrid from "@/components/TourGrid";
import Manifesto from "@/components/Manifesto";
import About from "@/components/About";
import Enquiry from "@/components/Enquiry";
import Footer from "@/components/Footer";

export default function Home() {
  const [preselectedTour, setPreselectedTour] = useState("");

  return (
    <div data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <TourGrid onRequestTour={setPreselectedTour} />
        <Marquee />
        <Manifesto />
        <About />
        <Enquiry preselectedTour={preselectedTour} onConsumePreselect={() => setPreselectedTour("")} />
      </main>
      <Footer onRequestTour={setPreselectedTour} />
    </div>
  );
}
